/**
 * Media (images/audio) generated for questions are hosted in the app's own
 * `public/` folder and referenced in question content by ABSOLUTE URLs that were
 * baked in at generation time (e.g. https://cert.mbulaholdings.com/examens-...png).
 *
 * The app now runs on a different domain, so those absolute URLs 404. Rewrite any
 * URL pointing at one of our own domains to a ROOT-RELATIVE path so the browser
 * loads it from whatever origin currently serves the site. External URLs (e.g.
 * intentional example links in question text) are left untouched.
 */
export function normalizeMediaSrc(src: string): string {
  if (!src) return src;
  return src.replace(/^https?:\/\/(?:[a-z0-9-]+\.)*mbulaholdings\.com/i, '');
}
